import React from 'react';

export interface tableColumn {
    label: string;
    key: string;
}

interface TableProps {
    tableData: any[];
    columns: tableColumn[];
}

export class ScrollableTable extends React.Component<TableProps> {

    render() {
        const data = this.props.tableData;
        const columns = this.props.columns;

        const containerStyle = {
            width: "100%",
            height: "100%",
            overflow: "auto",
            border: "1px solid #ccc",
        };

        return (
            <div style={containerStyle}>
                <table style={{borderCollapse: "collapse", width: "100%", minWidth: "max-content"}}>
                    <thead>
                        <tr>
                        {columns.map((col) => (
                            <th key={col.key} style={{border: "1px solid #ccc", padding: "8px", textAlign: "center", whiteSpace: "nowrap", fontSize: ".7rem"}}>
                            {col.label}
                            </th>
                        ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row: any, rowIndex: number) => (
                        <tr key={rowIndex}>
                            {columns.map((col) => (
                            <td key={col.key} style={{border: "1px solid #ccc", padding: ".5rem", textAlign: "left", whiteSpace: "nowrap", fontSize: ".6rem"}}>
                                {row[col.key]}
                            </td>
                            ))}
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}
